<div class="container-fluid  m-0 homepage">
    <div class="row homepage-content">
        <app-programs class="col-sm-3" *ngIf=loggedIn></app-programs>
        <div class="home-image" [ngClass]="{'home-image-no-overflow col-sm-9': loggedIn, 'home-image-no-login': !loggedIn}">
            <img src="../assets/home.jpg" class="">
        </div>
    </div>
</div>
